var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [
            _vm._v(" Show You're Making a Difference with GreenGeeks Seals ")
          ]),
          _c(
            "gg-card-text",
            {
              staticClass: "pa-4"
            },
            [
              _c("p", [
                _vm._v(
                  " Show off to your visitors that your website is making a difference by hosting on environmentally friendly hosting. Visitors will be able to verify that you host green by clicking on the GreenGeeks Seal. "
                )
              ]),
              _c(
                "v-row",
                {
                  staticClass: "text-center"
                },
                _vm._l(26, function(n) {
                  return _c(
                    "v-col",
                    {
                      key: "Green".concat(n),
                      attrs: {
                        cols: "6",
                        sm: "4",
                        md: "3",
                        lg: "2"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "tag-cnt"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tag-img"
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: ""
                                    .concat(_vm.tag_image_name)
                                    .concat(n, ".png"),
                                  alt: "GreenGeeks Seal ".concat(n)
                                }
                              })
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "tag-btn"
                            },
                            [
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    tile: "",
                                    elevation: "0",
                                    dark: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.switchModalState(n)
                                    }
                                  }
                                },
                                [
                                  _vm._v(" Get Code "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "visually-hidden text-lowercase"
                                    },
                                    [_vm._v("button")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      [
        _c("gg-modal", {
          attrs: {
            "is-active": _vm.modal
          },
          on: {
            close: function close($event) {
              _vm.modal = false
            }
          },
          scopedSlots: _vm._u([
            {
              key: "toolbar",
              fn: function fn() {
                return [_vm._v(" GreenGeeks seal tag ")]
              },
              proxy: true
            },
            {
              key: "body",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      " This is the tag you will place on your website to display your GreenGeeks Seal. When visitors click on the link, it will open a new window which verifies that your website is hosted on environmentally friendly servers by GreenGeeks. "
                    )
                  ]),
                  _c("v-textarea", {
                    attrs: {
                      label: "Code",
                      outlined: "",
                      value: _vm.codeblock,
                      rows: "8",
                      readonly: true
                    }
                  })
                ]
              },
              proxy: true
            },
            {
              key: "actions",
              fn: function fn() {
                return [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        primary: ""
                      },
                      on: {
                        click: _vm.switchModalState
                      }
                    },
                    [
                      _vm._v(" Close "),
                      _c(
                        "span",
                        {
                          staticClass: "visually-hidden text-lowercase"
                        },
                        [_vm._v("button")]
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }